'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function BlogNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[rgba(36,36,36,0.92)] backdrop-blur-[20px] border-b border-[rgba(255,255,255,0.08)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-3 group">
          <Image
            src="/assets/images/icon-1773382447570.png"
            alt="Amaze Insights Logo"
            width={40}
            height={40}
            className="flex-shrink-0"
            priority
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'Home', href: 'https://amaze.plus/' },
            { label: 'Services', href: 'https://amaze.plus/' },
            { label: 'Our Work', href: 'https://amaze.plus/' },
            { label: 'Blog', href: '/blog' },
            { label: 'Contact', href: 'https://contact.amaze.plus/' },
          ]?.map((item) => (
            <Link
              key={item?.label}
              href={item?.href}
              className="text-sm font-medium tracking-wide text-[rgba(255,255,255,0.6)] hover:text-white transition-colors duration-200"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {item?.label}
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            href="https://contact.amaze.plus/"
            className="px-5 py-2.5 rounded-xl text-sm font-semibold text-white transition-all duration-200 hover:opacity-90 hover:scale-[1.02]"
            style={{
              background: 'linear-gradient(135deg, #E58621, #E0442B)',
              fontFamily: "'Inter', sans-serif",
              fontWeight: 600,
            }}
          >
            Contact Us
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-5 h-0.5 bg-white transition-all duration-200 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-5 h-0.5 bg-white transition-all duration-200 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-5 h-0.5 bg-white transition-all duration-200 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[rgba(36,36,36,0.97)] backdrop-blur-[20px] border-t border-[rgba(255,255,255,0.08)] px-6 py-4 flex flex-col gap-4">
          {[
            { label: 'Home', href: 'https://amaze.plus/' },
            { label: 'Services', href: 'https://amaze.plus/' },
            { label: 'Our Work', href: 'https://amaze.plus/' },
            { label: 'Blog', href: '/blog' },
            { label: 'Contact', href: 'https://contact.amaze.plus/' },
          ]?.map((item) => (
            <Link
              key={item?.label}
              href={item?.href}
              className="text-sm font-medium text-[rgba(255,255,255,0.7)] hover:text-white transition-colors"
              style={{ fontFamily: "'Inter', sans-serif" }}
              onClick={() => setMenuOpen(false)}
            >
              {item?.label}
            </Link>
          ))}
          <Link
            href="https://contact.amaze.plus/"
            className="mt-2 px-5 py-2.5 rounded-xl text-sm font-semibold text-white text-center"
            style={{ background: 'linear-gradient(135deg, #E58621, #E0442B)', fontFamily: "'Inter', sans-serif" }}
          >
            Contact Us
          </Link>
        </div>
      )}
    </nav>
  );
}
